// extracted by mini-css-extract-plugin
module.exports = {"root":"buttonDanger_root__u0utg"};